import {
  PaginationResponse,
  ProductUnderlying,
  ProductUnderlyingGroup,
} from '../model';
import { GenericPaginatedModel } from '../model/generic-paginated-model';

export function array2PaginatedMap<T>(
  array: T[],
  pageInfo: PaginationResponse
): GenericPaginatedModel<T> {
  const map: GenericPaginatedModel<T> = {
    items: {},
    pageInfo: { ...pageInfo, count: array.length },
  };
  return array.reduce((acc, item, index) => {
    const page = Math.ceil((index + 1) / pageInfo.perPage);
    if (acc.items[page]) {
      acc.items[page].push(item);
    } else {
      acc.items[page] = [item];
    }
    return acc;
  }, map);
}

export function underlying2PaginatedMap(
  underlyingGroups: ProductUnderlyingGroup[],
  pageInfo: PaginationResponse
): GenericPaginatedModel<ProductUnderlyingGroup> {
  const map: GenericPaginatedModel<ProductUnderlyingGroup> = {
    items: {},
    pageInfo: { ...pageInfo },
  };
  let count = 0;
  underlyingGroups.forEach((group) =>
    group.underlying.forEach((underlying) => {
      const page = Math.floor(count / pageInfo.perPage) + 1;
      if (map.items[page]) {
        const g = map.items[page].find((gr) => gr.name === group.name);
        if (g) {
          (g.underlying as ProductUnderlying[]).push(underlying);
        } else {
          map.items[page].push({
            underlying: [underlying],
            type: group.type,
            name: group.name,
          });
        }
      } else {
        map.items[page] = [
          {
            underlying: [underlying],
            type: group.type,
            name: group.name,
          },
        ];
      }

      count += 1;
    })
  );

  map.pageInfo.count = count;
  return map;
}
